import brandonPic from "@/public/images/artists/brandon.png";
import { Artist } from "@/types/types";

export const brandon = {
  id: "178",
  name: "Brandon",
  image: brandonPic,
  description: `Brandon's voice has a grounded, earthy quality that's a natural fit for Americana and classic country. He brings a touch of old-school charm with the relaxed feel of '90s country, creating a sound that's both familiar and refreshingly authentic`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Fbrandon-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Male",
    tags: {
      primary: ["Country", "Folk", "Unprocessed", "Deep"],
      secondary: ["Americana"],
    },
    pitchRange: {
      categories: {
        low: "Bass",
        high: "Mid",
      },
      specific: {
        low: 38,
        high: 70,
      },
      sweetSpot: 57,
    },
  },
} as const satisfies Artist;
